import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { ISubscribe, ISubscribeInput } from "@/interfaces/subscribe.interfaces";
import subscriptionService from "@/services/subscription.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateSubscriptionProps = {
  formData: ISubscribeInput;
} & RequestsProps;

export type UseCreateSubscriptionReturn = {
  create: (props: CreateSubscriptionProps) => Promise<ISubscribe>;
} & UseLoadingReturn;

const useCreateSubscription = (): UseCreateSubscriptionReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<ISubscribeInput>({
    operation: (formData) => subscriptionService.createSubscription(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateSubscription;
